module.exports = __webpack_public_path__ + "static/img/head.4fcd47b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head.jpg
// module id = lBov
// module chunks = 2